export default __webpack_public_path__ + "static/media/digitalocean-horizontal.e6d83b9c.svg";